import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { FiChevronDown } from "react-icons/fi";

import logo from '../../assets/img/logoblanco.png'
import users from '../../assets/img/svg/users.svg'
import addImg from '../../assets/img/svg/add.svg'
import bar from '../../assets/img/svg/bar.svg'
import loginImg from '../../assets/img/svg/login.svg'
import { useUser } from '../../context/UserContext';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth, db } from '../../firebaseConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import LanguageToggle from '../LanguageToggle';
import { getFirebaseErrorMessage } from '../../utils/errorMessages';

export default function Navbar({transparent}:{transparent:any}) {
    const { t } = useTranslation();
    const [activeMenu, setActiveMenu] = useState<{[key: string]: { [key: string]: boolean };}>({});
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [toggle, setIsToggle] = useState<boolean>(false);
    const [login, setLogin] = useState<boolean>(false);
    const { setUser, user, logout, loading: userLoading } = useUser();
    const navigate = useNavigate();
    const [justLoggedIn, setJustLoggedIn] = useState(false);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const [resetMessage, setResetMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    let[scroll,setScroll] = useState<boolean>(false)

    const location = useLocation();
    const current = location.pathname

    // Cargar solo email guardado
    useEffect(() => {
        const savedEmail = localStorage.getItem('ampi_saved_email');
        localStorage.removeItem('ampi_saved_password');
        if (savedEmail) {
            setEmail(savedEmail);
            setRememberMe(true);
        }
    }, []);

    // Redirigir a seleccionar-rol si el usuario tiene permisos de comité después del login
    useEffect(() => {
        if (justLoggedIn && !userLoading && user) {
            setJustLoggedIn(false);
            if (user.esAdminComite) {
                navigate('/seleccionar-rol');
            }
        }
    }, [justLoggedIn, userLoading, user, navigate]);

    const handleLogin = async () => {
        if (user) {
          setError(t('auth.alreadyLoggedIn'));
          return;
        }
        try {
          await signInWithEmailAndPassword(auth, email, password);
          if (rememberMe) {
            localStorage.setItem('ampi_saved_email', email);
          } else {
            localStorage.removeItem('ampi_saved_email');
          }
          setUser(null);
          setLogin(false);
          setEmail('');
          setPassword('');
          setError('');
          setJustLoggedIn(true);
        } catch (err: any) {
          console.error(err.message);
          setError(getFirebaseErrorMessage(err));
        }
      };

      const handleForgotPassword = async () => {
        if (!resetEmail) {
          setResetMessage('Por favor, ingresa tu correo electrónico.');
          return;
        }
        try {
          const [adminSnap, asociadoSnap, asesorSnap] = await Promise.all([
            getDocs(query(collection(db, 'admin'), where('correo', '==', resetEmail))),
            getDocs(query(collection(db, 'asociado'), where('correo', '==', resetEmail))),
            getDocs(query(collection(db, 'asesor'), where('correo', '==', resetEmail)))
          ]);
          const correoExiste = !adminSnap.empty || !asociadoSnap.empty || !asesorSnap.empty;
          if (!correoExiste) {
            setResetMessage('No existe una cuenta registrada con este correo electrónico.');
            return;
          }
          await sendPasswordResetEmail(auth, resetEmail);
          setResetMessage('Se ha enviado un correo con instrucciones para restablecer tu contraseña.');
        } catch (err: any) {
          console.error(err);
          setResetMessage(getFirebaseErrorMessage(err));
        }
      };

    const handleMouseEnter = (menu: string, submenu?: string) => {
        setActiveMenu((prev) => ({
          ...prev,
          [menu]: { ...prev[menu], [submenu || 'main']: true },
        }));
      };

      const handleMouseLeave = (menu: string, submenu?: string) => {
        setActiveMenu((prev) => ({
          ...prev,
          [menu]: { ...prev[menu], [submenu || 'main']: false },
        }));
      };

    useEffect(()=>{
        window.scrollTo(0,0)
        const handlerScroll = () =>{
            if(window.scrollY > 50){ setScroll(true) } else { setScroll(false) }
          };
        const handleResize = () => { setWindowWidth(window.innerWidth); };
        window.addEventListener('scroll',handlerScroll)
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll',handlerScroll)
            window.removeEventListener('resize', handleResize);
          };
    },[windowWidth])


  return (
    <>
        {/* ========== CONVENTIONAL NAVBAR ========== */}
        <div className={`header ${scroll ? 'header-fixed' : ''} ${transparent ? 'header-transparent dark' : 'header-light head-shadow'}`}>
            <div className="container">
                <nav id="navigation " className={windowWidth > 991 ? "navigation navigation-landscape" : "navigation navigation-portrait"}>
                    <div className="nav-header" style={{lineHeight:'0'}}>
                        <Link className="nav-brand text-logo" to="/">
                            <img src={logo} alt="Logo AMPI Riviera Nayarit" />
                        </Link>
                        <button className="nav-toggle" onClick={()=>setIsToggle(!toggle)} aria-label="Abrir menú de navegación" aria-expanded={toggle}></button>
                        <div className="mobile_nav">
                            <ul>
                                {!user && (
                                    <li>
                                        <Link to="#" onClick={()=>setLogin(!login)}>
                                            <img src={users} alt="Iniciar sesión" />
                                        </Link>
                                    </li>
                                )}
                                {user && (
                                    <li>
                                        <Link to={user.rol === 'ADMIN' ? '/admin-dashboard' : '/dashboard'} className="text-primary">
                                            <img src={loginImg} alt="Mi panel de control" />
                                        </Link>
                                    </li>
                                )}
                                <li>
                                    <Link to="/submit-property" className="text-primary">
                                        <img src={addImg} alt="Publicar propiedad" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" className="text-primary">
                                        <img src={bar} alt="Menú" />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={`nav-menus-wrapper  ${toggle ? 'nav-menus-wrapper-open' : ''}`} style={{transitionProperty:toggle ? 'none' : 'left'}}>
                        <button className="nav-menus-wrapper-close-button" onClick={()=>setIsToggle(!toggle)} aria-label="Cerrar menú de navegación">✕</button>
                        <ul className="nav-menu" style={{float:'right'}}>
                            <li className={`${['/','/home-2','/home-3','/home-4','/home-5','/home-6','/home-7','/home-8','/home-9','/home-10','/home-11','/video','/map'].includes(current) ? 'active' : ''} ${activeMenu['home']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('home')} onMouseLeave={() => handleMouseLeave('home')}><Link to="/">{t('navigation.home')}</Link>
                            </li>

                            <li className={current === '/classical-layout-with-sidebar' ? 'active' : ''}>
                                <Link to="/classical-layout-with-sidebar">{t('navigation.properties')}</Link>
                            </li>

                            <li className={`${['/agents','/agent-page','/asociados','/asociado-page'].includes(current)?'active':''} ${activeMenu['members']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('members')} onMouseLeave={() => handleMouseLeave('members')}>
                                <Link to="#">{t('navigation.members')}<FiChevronDown className="submenu-indicator"/></Link>
                                <ul className="nav-dropdown nav-submenu" style={{display: activeMenu['members']?.main ? 'block' : 'none', pointerEvents: activeMenu['members']?.main ? 'auto' : 'none'}}>
                                    <li><Link to="/agents" className={current === '/agents' ? 'active' : ''}>{t('navigation.affiliates')}</Link></li>
                                    <li><Link to="/asociados" className={current === '/asociados' ? 'active' : ''}>{t('navigation.associates')}</Link></li>
                                </ul>
                            </li>

                            <li className={['/agencies','/agency-page'].includes(current)?'active':''}><Link to="/agencies">{t('agency.agencies')}</Link></li>

                            <li className={current === '/ver-taller' ? 'active' : ''}>
                                <Link to="/ver-taller">Cursos y Talleres</Link>
                            </li>

                            {user && (
                                <li className={`${['/dashboard','/my-profile','/bookmark-list','/change-password','/calificacion'].includes(current)?'active':''} ${activeMenu['account']?.main ? 'show' : ''}`} onMouseEnter={() => handleMouseEnter('account')} onMouseLeave={() => handleMouseLeave('account')}>
                                    <Link to="#">{t('navigation.myAccount')}<FiChevronDown className="submenu-indicator"/></Link>
                                    <ul className="nav-dropdown nav-submenu" style={{display: activeMenu['account']?.main ? 'block' : 'none', pointerEvents: activeMenu['account']?.main ? 'auto' : 'none'}}>
                                        <li><Link to="/dashboard" className={current === '/dashboard' ? 'active' : ''}>{t('navigation.dashboard')}</Link></li>
                                        <li><Link to="/calificacion" className={current === '/calificacion' ? 'active' : ''}>{t('navigation.addReview')}</Link></li>
                                    </ul>
                                </li>
                            )}

                            {user && (
                                <li className="d-lg-none">
                                    <Link to={user.rol === 'ADMIN' ? '/admin-dashboard' : '/dashboard'} className="fw-medium text-primary">
                                        {t('navigation.dashboard')}
                                    </Link>
                                </li>
                            )}

                            <li className="d-none d-lg-inline-block" style={{paddingTop:14}}>
                              <LanguageToggle />
                            </li>
                            {!user && (
                              <li className="d-none d-lg-inline-block">
                                <Link to="#" className="fw-medium text-muted-2" onClick={(e) => {
                                  e.preventDefault();
                                  setLogin(!login);
                                }}>
                                  <span className="svg-icon svg-icon-2hx">
                                    <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"/>
                                      <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.575 12.675 3.975 14.55C5.25 15.75 7.05 16.5 9 16.5Z" fill="currentColor"/>
                                      <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"/>
                                    </svg>
                                  </span>
                                </Link>
                              </li>
                            )}
                            {user && (
                              <>
                                <li className="add-listing d-none d-lg-inline-block me-3">
                                  <Link to={user.rol === 'ADMIN' ? '/admin-dashboard' : '/dashboard'} className="bg-primary">
                                    <img src={loginImg} alt="Icono panel de control" className="me-1" />
                                    {t('navigation.dashboard')}
                                  </Link>
                                </li>
                                <li className="d-none d-lg-inline-block">
                                  <span className="fw-medium text-muted-2">
                                    {t('navigation.hello')}, {user.nombre?.split(' ')[0] || 'Usuario'}
                                  </span>
                                </li>
                                <li className="d-none d-lg-inline-block">
                                  <button onClick={logout} className="btn btn-outline-secondary btn-sm ms-2">
                                    {t('navigation.logout')}
                                  </button>
                                </li>
                              </>
                            )}
                        </ul>
                    </div>
                    <div className="nav-overlay-panel" style={{backgroundColor: 'rgba(0, 0, 0, 0.5)', display: toggle ?  'block' : 'none'}}></div>
                </nav>
            </div>
        </div>
        <div className="clearfix"></div>

        {/* ========== FLOATING BUTTON - SITIO OFICIAL ========== */}
        <a
            href="https://ampirivieranayarit.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visitar sitio oficial AMPI"
            style={{
                position: 'fixed', bottom: 70, right: 24, zIndex: 1050,
                width: 52, height: 52, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backgroundColor: '#1a5d4a',
                boxShadow: '0 4px 16px rgba(26,93,74,0.4)',
                color: '#fff', fontSize: 22, textDecoration: 'none',
                transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
        >
            <i className="fa fa-globe" aria-hidden="true"></i>
        </a>

        {/* Login modal */}
        {login &&
            <div className="modal fade show" style={{display: 'block', backgroundColor:"#0000008a"}}>
                <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                    <div className="modal-content" id="registermodal">
                        <button className="mod-close" onClick={()=>setLogin(!login)} aria-label="Cerrar ventana de inicio de sesión" type="button">
                            <span className="svg-icon text-primary svg-icon-2hx" aria-hidden="true">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                    <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"></rect>
                                    <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"></rect>
                                </svg>
                            </span>
                        </button>
                        <div className="modal-body">
                            <h4 className="modal-header-title">{t('auth.loginTitle')}</h4>
                            <div className="d-flex align-items-center justify-content-center mb-3">
                            <span className="svg-icon svg-icon-2hx d-inline-flex align-items-center justify-content-center">
                            <img src={logo} alt="Icono AMPI" width={170} height={70} loading="lazy" />
                          </span>
                            </div>
                            <div className="login-form">
                                <form>
                                    <div className="form-floating mb-3">
                                    <input type="email" className="form-control" placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    {error && <p className="text-danger mt-2">{error}</p>}
                                    <label>{t('auth.emailAddress')}</label>
                                    </div>

                                    <div className="form-floating mb-3 position-relative">
                                    <input type={showPassword ? "text" : "password"} className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ paddingRight: '45px' }} />
                                    <button
                                      type="button"
                                      className="btn position-absolute border-0"
                                      onClick={() => setShowPassword(!showPassword)}
                                      style={{ right:'5px', top:'50%', transform:'translateY(-50%)', padding:'0.375rem 0.75rem', zIndex:10, background:'transparent', textDecoration:'none' }}
                                      title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                      aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                      aria-pressed={showPassword}
                                    >
                                      <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-muted`} aria-hidden="true"></i>
                                    </button>
                                    {error && <p className="text-danger mt-2">{error}</p>}
                                    <label>{t('auth.password')}</label>
                                    </div>

                                    <div className="form-group mb-3">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="flex-shrink-0 flex-first">
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="checkbox" id="save-pass" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
                                                    <label className="form-check-label" htmlFor="save-pass">{t('auth.savePassword')}</label>
                                                </div>
                                            </div>
                                            <div className="flex-shrink-0 flex-first">
                                                <button type="button" className="btn btn-link link fw-medium p-0" onClick={() => setShowForgotPassword(true)}>
                                                    {t('auth.forgotPassword')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                    <button type="button" className="btn btn-lg btn-primary fw-medium full-width rounded-2" onClick={handleLogin}>{t('auth.loginButton')}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        {/* Modal para recuperar contraseña */}
        {showForgotPassword &&
            <div className="modal fade show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t('auth.recoverPasswordTitle')}</h4>
                            <button type="button" className="btn-close" onClick={() => { setShowForgotPassword(false); setResetEmail(''); setResetMessage(''); }}></button>
                        </div>
                        <div className="modal-body">
                            <div className="login-form">
                                <p className="text-muted mb-3">{t('auth.recoverPasswordText')}</p>
                                <div className="form-floating mb-3">
                                    <input type="email" className="form-control" placeholder="name@example.com" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} />
                                    <label>{t('auth.emailAddress')}</label>
                                </div>
                                {resetMessage && (
                                    <div className={`alert ${resetMessage.includes('enviado') ? 'alert-success' : 'alert-danger'} mb-3`}>{resetMessage}</div>
                                )}
                                <div className="form-group">
                                    <button type="button" className="btn btn-primary full-width" onClick={handleForgotPassword}>{t('auth.sendRecoveryEmail')}</button>
                                </div>
                                <div className="text-center mt-3">
                                    <button type="button" className="btn btn-link" onClick={() => setShowForgotPassword(false)}>{t('auth.backToLogin')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

    </>
  )
}
